module.exports = __webpack_public_path__ + "img/default-avatar.42590e3c.png";